import { FieldArrayType, FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import type { FieldArrayTypeConfig } from '@ngx-formly/core';

import { canMutateField } from './readonly.types';

/**
 * K4 (reuse): the byte-identical `canMutate(): boolean { return canMutateField(this.field); }`
 * wrapper was hand-copied across every OWN-VIEW field component built on `FieldType` —
 * inline-entries, linkage-items, form-builder, required-items, onboarding-prefill-mapping.
 * Extend this instead of `FieldType` directly and drop the local copy.
 *
 * Not for every own-view type: `linked-items` (`readOnlyItems()`) and `signing-sign` (`canSign()`,
 * not `canMutate()`) each add a real extra condition on top of `canMutateField` and stay on plain
 * `FieldType` with their own method — see `canMutateField`'s docblock (`readonly.types.ts`) for
 * why that extra logic belongs on the component, not here.
 */
export abstract class OwnViewFieldType<F extends FormlyFieldConfig = FormlyFieldConfig> extends FieldType<F> {
  canMutate(): boolean {
    return canMutateField(this.field);
  }
}

/**
 * Same as {@link OwnViewFieldType}, for the one own-view component built on `FieldArrayType`
 * (`repeat-accordion`). Default generic mirrors `FieldArrayType`'s own (`FieldArrayTypeConfig`,
 * not plain `FormlyFieldConfig`) so a subclass extending without an explicit type param keeps the
 * same `formControl: UntypedFormArray` typing it had extending `FieldArrayType` directly.
 */
export abstract class OwnViewFieldArrayType<
  F extends FormlyFieldConfig = FieldArrayTypeConfig,
> extends FieldArrayType<F> {
  canMutate(): boolean {
    return canMutateField(this.field);
  }
}
